import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import '../styles/Products.css';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ loading state
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get("https://dummyjson.com/products")
      .then((res) => {
        setProducts(res.data.products); // ✅ correct
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="products-container">
      <h1 className="products-title">Shop Products</h1>

      <div className="button-container">
        <button className="home-btn" onClick={() => navigate('/')}>Home</button>
        <button className="home-btn" onClick={() => navigate('/products')}>Products</button>
        <button className="home-btn" onClick={() => navigate('/cart')}>Cart</button>
      </div>

      <div className="product-grid">
        {loading ? (
          <h2>Loading products...</h2>
        ) : Array.isArray(products) && products.length > 0 ? (
          products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))
        ) : (
          <h2>No products found</h2>
        )}
      </div>
    </div>
  );
};

export default Products;